import { PurchaseChannel } from '../enums/purchase-channel.enum';
import Env from '../../env';

export function getPurchaseChannel(env: Env): PurchaseChannel {
    switch (env.CHANNEL) {
        case 'mobile':
            return PurchaseChannel.MOBILE;
        case 'web':
        case 'web_corp':
        default:
            return PurchaseChannel.WEB;
    }
}
